
import React from "react";
import { Button } from "@/components/ui/button";

interface NoResultsProps {
  searchQuery: string;
  onClearSearch: () => void;
}

const NoResults: React.FC<NoResultsProps> = ({ searchQuery, onClearSearch }) => {
  return (
    <div className="col-span-full text-center py-12">
      <p className="text-lg text-muted-foreground">No products found matching "{searchQuery}"</p>
      <Button 
        variant="outline" 
        className="mt-4 button-hover"
        onClick={onClearSearch}
      >
        Clear Search
      </Button>
    </div>
  );
};

export default NoResults;
